import React, { useEffect, useState } from "react";
import { IonContent, IonModal } from "@ionic/react";
import { ISaveDraftModal } from "@interfaces/Components";

const SaveDraftModal: React.FC<ISaveDraftModal> = (props) => {
  const [visible, setVisible] = useState<boolean>(false);

  useEffect(() => {
    setVisible(props.visible);
  }, [props.visible]);

  return (
    <IonModal
      id="save-draft-modal"
      isOpen={visible}
      backdropDismiss={false}
      canDismiss={true}
      onDidDismiss={() => setVisible(false)}
      className="fullscreen"
    >
      <IonContent>
        <div className="flex flex-col justify-between h-full">
          <div className="mt-[16px] px-[16px]">
            <div className="text-[20px] font-bold leading-default tracking-[-0.1px] text-center text-grey-90">
              {"Save this draft for later"}
            </div>
            <div className="text-[15px] leading-[1.33] tracking-[-0.3px] text-center text-grey-90">
              {"Continue editing this draft at a later date or discard what you've added to this draft"}
            </div>
          </div>
          <div className="flex flex-col">
            <div className="border-t border-t-grey-30">
              <button
                className="h-[48px] w-full"
                onClick={props.savePressed}
              >
                <div className="text-[16px] font-semibold leading-default tracking-default text-center text-cta-blue">
                  {"Save draft"}
                </div>
              </button>
            </div>
            <div className="border-t border-t-grey-30">
              <button
                className="h-[48px] w-full"
                onClick={props.deletePressed}
              >
                <div className="text-[16px] font-semibold leading-default tracking-default text-center text-cta-red">
                  {"Delete evidence"}
                </div>
              </button>
            </div>
            <div className="border-t border-t-grey-30">
              <button
                className="h-[48px] w-full"
                onClick={props.cancelPressed}
              >
                <div className="text-[16px] leading-default tracking-default text-center text-cta-blue">{"Cancel"}</div>
              </button>
            </div>
          </div>
        </div>
      </IonContent>
    </IonModal>
  );
};

export default SaveDraftModal;
